module.exports = __webpack_public_path__ + "static/media/clipboard.a0855d9b.svg";